"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modeDisplay = exports.TopicMode = void 0;
var TopicMode;
(function (TopicMode) {
    TopicMode["General"] = "General";
    TopicMode["BoardGame"] = "BoardGame";
})(TopicMode = exports.TopicMode || (exports.TopicMode = {}));
;
function modeDisplay(mode) {
    if (mode === TopicMode.BoardGame) {
        return "Board Game";
    }
    else {
        return "General";
    }
}
exports.modeDisplay = modeDisplay;
//# sourceMappingURL=topic.dto.js.map